import { createFileRoute } from "@tanstack/react-router";
import { PageHero } from "@/components/site/PageHero";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms & Conditions: IZHUB Cleaning Service" },
      { name: "description", content: "The terms and conditions that apply when you book IZHUB Cleaning Service." },
      { property: "og:title", content: "Terms & Conditions: IZHUB Cleaning Service" },
      { property: "og:description", content: "The terms and conditions that apply when you book IZHUB Cleaning Service." },
      { name: "robots", content: "noindex" },
      { property: "og:url", content: "https://izhubcleaning.uk/terms" },
    ],
    links: [{ rel: "canonical", href: "https://izhubcleaning.uk/terms" }],
  }),
  component: Terms,
});

function Terms() {
  return (
    <>
      <PageHero title="Terms & Conditions" intro="The basics of working with us." />
      <section className="pb-24">
        <article className="container-x text-surface max-w-3xl space-y-6 text-foreground/90">
          <p className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString("en-GB", { month: "long", year: "numeric" })}</p>

          <h2 className="font-display text-2xl">Booking a clean</h2>
          <p>A booking is confirmed once we have agreed a date, price and scope of work in writing (including by email, WhatsApp or SMS).</p>

          <h2 className="font-display text-2xl">Quotes</h2>
          <p>Quotes are based on the information you provide. If, on arrival, the property differs significantly from what was described, we may need to adjust the price and will discuss this with you before continuing.</p>

          <h2 className="font-display text-2xl">Payment</h2>
          <p>Payment terms will be confirmed with your quote. Unless agreed otherwise, payment is due on completion of the clean.</p>

          <h2 className="font-display text-2xl">Cancellations</h2>
          <p>Please give us as much notice as possible if you need to reschedule or cancel. Cancellations with less than 24 hours' notice may incur a charge.</p>

          <h2 className="font-display text-2xl">Access</h2>
          <p>You are responsible for ensuring safe access to the property at the agreed time. If we are unable to gain access, a call-out charge may apply.</p>

          <h2 className="font-display text-2xl">Our standard</h2>
          <p>We take pride in our work. If you are unhappy with any part of a clean, please let us know within 24 hours and we will do our best to put it right.</p>

          <h2 className="font-display text-2xl">Insurance & liability</h2>
          <p>We hold public liability insurance. Our liability is limited to the value of the clean carried out, except where liability cannot be limited by law.</p>

          <h2 className="font-display text-2xl">Governing law</h2>
          <p>These terms are governed by the laws of England and Wales.</p>

          <p className="text-sm text-muted-foreground pt-6 border-t border-border">These terms are provided as a starting point and can be updated as needed. For anything urgent, contact us at <a href="mailto:info@izhubcleaning.uk" className="text-primary underline">info@izhubcleaning.uk</a>.</p>
        </article>
      </section>
    </>
  );
}
